// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AvatarButtonGroup, Tag } from 'src/design-system'
import { CellContext } from '@tanstack/react-table'
import { avatarGroupProps } from 'app/packs/src/utils/user-helpers'
import { observer } from 'mobx-react-lite'
import * as React from 'react'
import { store } from 'store/index'
import { OrgSkillGapsTableRow } from '../data'
import { Lightbulb } from '@phosphor-icons/react'

export const PeopleCell = observer(
  (data: CellContext<OrgSkillGapsTableRow, string[]>) => {
    const { first3UserIds, userCount } = data.row.original
    const users = first3UserIds.flatMap((id) => store.users.byId(id) || [])

    const handleBulbClick = (e: React.MouseEvent) => {
      e.preventDefault()
      e.stopPropagation()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const columnDef = data.column.columnDef as any
      if (columnDef.meta?.onDrawerClick) {
        columnDef.meta.onDrawerClick(data.row.original)
      }
    }

    return (
      <div className="flex items-center gap-2">
        {userCount}
        <AvatarButtonGroup
          avatars={avatarGroupProps(users, { href: false, stateTooltip: true })}
          size="xs"
        />
        <button
          onClick={handleBulbClick}
          className="cursor-pointer hover:bg-gray-50 rounded p-1 transition-colors"
          aria-label="Open people using details"
        >
          <Lightbulb size={13} className="text-gray-500" weight="regular" />
        </button>
      </div>
    )
  }
)
